import React, { useEffect, useState } from 'react'
import { useTheme } from '@mui/material/styles'
import { Box, Button, Link, Paper, Typography } from '@mui/material'

import { isMobileDevice, isIOS } from '../../utils/utilities'

import logo from 'assets/icons/contenthouse.svg'
import config from 'config'

const getAppPath = () => {
  const path = window.location.pathname.replace(/^\//, '')

  // /project/:id
  const projectMatch = path.match(/^project\/([^/]+)$/)
  if (projectMatch) {
    return `projects/${projectMatch[1]}/assets`
  }

  // // /project/:id/bookings
  // const bookingsMatch = path.match(/^project\/([^/]+)\/bookings$/)
  // if (bookingsMatch) {
  //   // No orderId available, so just map to /project/:id/order
  //   return `project/${bookingsMatch[1]}/order`
  // }

  // // /project/:id/task/:taskId/files
  // const filesMatch = path.match(/^project\/([^/]+)\/task\/([^/]+)\/files$/)
  // if (filesMatch) {
  //   // TDB: To be defined, for now just return the same path
  //   return `project/${filesMatch[1]}/task/${filesMatch[2]}/files`
  // }

  return ''
}

const MobileAppPrompt = () => {
  const [showPrompt, setShowPrompt] = useState(false)

  const theme = useTheme()

  useEffect(() => {
    if (isMobileDevice() && config.env !== 'production') {
      setShowPrompt(true)
    }
  }, [])

  const handleOpenApp = () => {
    const appPath = getAppPath()
    const deepLink = `${config.appDeepLinkScheme}/${appPath}`
    const storeUrl = isIOS() ? config.appStoreUrl : config.playStoreUrl

    window.location = deepLink
    // For iOS: must be in direct user gesture
    setTimeout(() => {
      if (isIOS()) {
        if (document.visibilityState === 'visible') {
          window.open(storeUrl, '_blank')
        }
      } else {
        window.open(storeUrl, '_blank')
      }
    }, 1500)
  }

  if (!showPrompt) return null

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        bgcolor: 'rgba(0,0,0,0.5)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Paper
        elevation={8}
        sx={{
          borderRadius: 2,
          p: 4,
          maxWidth: 340,
          width: '90%',
          textAlign: 'center',
        }}
      >
        <img src={logo} alt="Content House Logo" width={50} height={50} />
        <Typography variant="h3" component="h2" gutterBottom sx={{ mt: 2 }}>
          Open in Mobile App?
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          For the best experience, open this page in our mobile app.
        </Typography>
        <Button variant="contained" color="primary" onClick={handleOpenApp} sx={{ mt: 2, mb: 1 }} fullWidth>
          Open App
        </Button>
        <Link variant="body2" underline="hover" sx={{ color: theme.palette.grey[500] }} onClick={() => setShowPrompt(false)}>
          Not now
        </Link>
      </Paper>
    </Box>
  )
}

export default MobileAppPrompt
